export enum TicketTypesEnum {
  Connection = 1,
  AdditionalOrder,
  LocalOrder,
  GlobalProblem,
  CorrectionContract,
  Relocation,
  GlobalProblemGRS
}
